import { SearchPipe } from '@/types/pipe'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const pipeDataConfigApi = {
  getAll(searchParams: SearchPipe) {
    const url = '/api/v2/pipe/pure'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getPipeDropDown(interfaceId: number) {
    const url = `/api/pipe/dropdown-pipe?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/pipe/${interfaceId}/${id}`
    return axiosClient.get(url)
  },
}

export default pipeDataConfigApi
